// extracted by mini-css-extract-plugin
export default {"comparable-home-marker":"comparable-home-marker-c00e","comparable-home-text":"comparable-home-text-1d38","hover":"hover-63b2"};